module.exports = __webpack_public_path__ + "media/images/teams/logo__62-81666d8df7e7ce1538dd688dfcd81dd3.svg";